import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'player',
	prefix: 'player',
	key: 'player_id',
	fields: {
		player_id: Model.SCHEMA_KEY,
		play_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		player_name: Model.SCHEMA_TEXT,
		player_username: Model.SCHEMA_TEXT,
		player_start: Model.SCHEMA_NUMBER,
		player_color: Model.SCHEMA_TEXT,
		player_score: Model.SCHEMA_TEXT,
		player_new: Model.SCHEMA_NUMBER,
		player_rating: Model.SCHEMA_TEXT,
		player_win: Model.SCHEMA_NUMBER
	}
})
